import { StatisticEntry } from '@/api/generated'

export interface OrganisationStatisticsViewModel {
  numberOfVisits: number
  visits: StatisticEntry[]
}

export const EmptyOrganisationStatisticsViewModel: OrganisationStatisticsViewModel = {
  numberOfVisits: 0,
  visits: [],
}
